import { render, staticRenderFns } from "./BlockReports.vue?vue&type=template&id=fa90b3c0"
import script from "./BlockReports.vue?vue&type=script&lang=js"
export * from "./BlockReports.vue?vue&type=script&lang=js"
import style0 from "./BlockReports.vue?vue&type=style&index=0&id=fa90b3c0&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports